import "./styles.css";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import TeleinBanner from "../../assets/images/telein-banner.png";
import CustomSnackbar from "../../components/CustomSnackbar";
import {
  Visibility,
  VisibilityOff,
  ArrowBackOutlined,
  Login as LoginIcon,
} from "@mui/icons-material";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { patchRequest, postRequest } from "../../utils/services";
import { useSnackbar } from "../../context/SnackbarContext";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const {
    loginInfo,
    setLoginInfo,
    setUser,
    needsCreatePassword,
    setNeedsCreatePassword,
    newPassword,
    setNewPassword,
  } = useContext(AuthContext);

  const { showSnackbar } = useSnackbar();

  const handleBackToFeedback = () => {
    setLoginInfo({
      email: "",
      senha: "",
    });
    setNeedsCreatePassword(false);

    navigate("/");
  };

  const handleEmailChange = (e) => {
    const { value } = e.target;

    setLoginInfo((prev) => ({
      ...prev,
      email: value,
    }));
  };

  const handlePasswordChange = (e) => {
    const { value } = e.target;

    setLoginInfo((prev) => ({
      ...prev,
      senha: value,
    }));
  };

  const handleNewPasswordChange = (e) => {
    const { value } = e.target;

    setNewPassword(value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const response = await postRequest(
      `${import.meta.env.VITE_API_BASE_URL}/auth/login.php`,
      loginInfo
    );

    if (response.error) {
      if (response.message === "Usuário não possui senha.") {
        showSnackbar(response.message, "error");
        setNeedsCreatePassword(true);
        setLoginInfo((prev) => ({
          ...prev,
          senha: "",
        }));
        setNewPassword("");
        return;
      }

      showSnackbar(response.message, "error");
      setLoginInfo({
        email: "",
        senha: "",
      });

      return;
    }

    localStorage.setItem("User", JSON.stringify(response.dados));
    setUser(response.dados);
    setLoginInfo({
      email: "",
      password: "",
    });

    navigate("/home");
  };

  const handleRegisterPassword = async (e) => {
    e.preventDefault();

    const response = await patchRequest(
      `${import.meta.env.VITE_API_BASE_URL}/auth/cadastrarSenha.php`,
      loginInfo
    );

    if (response.error) {
      showSnackbar(response.message, "error");

      setLoginInfo({
        email: "",
        senha: "",
      });

      return;
    }

    setNeedsCreatePassword(false);
    showSnackbar(response.message, "success");
  };

  return (
    <Box
      sx={{
        height: "90%",
        p: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          p: 4,
          borderRadius: 2,
          overflowX: "auto",
          maxHeight: "95%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              marginBottom: "20px",
            }}
          >
            <Button
              variant="text"
              size="large"
              onClick={handleBackToFeedback}
              startIcon={<ArrowBackOutlined />}
              sx={{
                fontFamily: "JetBrains Mono, sans-serif",
              }}
            >
              Voltar
            </Button>
          </div>
          <Grid
            container
            spacing={2}
            sx={{
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img
              className="telein-banner"
              src={TeleinBanner}
              alt="Logomarca Telein"
              width="250"
              height="auto"
            />

            <Typography
              variant="h4"
              component="h1"
              sx={{
                mb: 2,
                fontWeight: "500",
                WebkitBackgroundClip: "text",
                fontSize: "28px",
                marginTop: "22px",
                color: "#9e9e9e",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              Inicie sua sessão
            </Typography>
          </Grid>

          <form
            onSubmit={
              needsCreatePassword ? handleRegisterPassword : handleLogin
            }
            style={{
              minWidth: "400px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Grid spacing={2} sx={{ mb: 3, width: "100%" }}>
              <TextField
                fullWidth
                label="Seu e-mail"
                id="email"
                variant="outlined"
                value={loginInfo.email}
                onChange={handleEmailChange}
                type="email"
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#9e9e9e",
                      fontFamily: "Montserrat, sans-serif",
                      fontStyle: "italic",
                    },
                  },
                }}
              />
            </Grid>

            {needsCreatePassword ? (
              <>
                <Grid
                  spacing={2}
                  sx={{ mb: 3, position: "relative", width: "100%" }}
                >
                  <TextField
                    fullWidth
                    label={
                      loginInfo.senha !== newPassword
                        ? "Senhas diferentes"
                        : "Sua nova senha"
                    }
                    id="senha"
                    error={loginInfo.senha !== newPassword}
                    value={loginInfo.senha}
                    onChange={handlePasswordChange}
                    type={showPassword ? "text" : "password"}
                    sx={{ width: "100%" }}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        sx: {
                          color: "#9e9e9e",
                          fontFamily: "Montserrat, sans-serif",
                          fontStyle: "italic",
                        },
                      },
                    }}
                  />
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{
                      position: "absolute",
                      right: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9e9e9e",
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Grid>
                <Grid
                  spacing={2}
                  sx={{ mb: 3, position: "relative", width: "100%" }}
                >
                  <TextField
                    fullWidth
                    label="Confirme sua nova senha"
                    id="nova-senha"
                    error={loginInfo.senha !== newPassword}
                    value={newPassword}
                    onChange={handleNewPasswordChange}
                    type={showPassword ? "text" : "password"}
                    sx={{ width: "100%" }}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        sx: {
                          color: "#9e9e9e",
                          fontFamily: "Montserrat, sans-serif",
                          fontStyle: "italic",
                        },
                      },
                    }}
                  />
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    sx={{
                      position: "absolute",
                      right: 16,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9e9e9e",
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Grid>
              </>
            ) : (
              <Grid
                spacing={2}
                sx={{ mb: 3, position: "relative", width: "100%" }}
              >
                <TextField
                  fullWidth
                  label="Sua senha"
                  id="senha"
                  value={loginInfo.senha}
                  onChange={handlePasswordChange}
                  type={showPassword ? "text" : "password"}
                  sx={{ width: "100%" }}
                  variant="outlined"
                  slotProps={{
                    inputLabel: {
                      sx: {
                        color: "#9e9e9e",
                        fontFamily: "Montserrat, sans-serif",
                        fontStyle: "italic",
                      },
                    },
                  }}
                />
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#9e9e9e",
                  }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </Grid>
            )}

            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={needsCreatePassword && loginInfo.senha !== newPassword}
              endIcon={!needsCreatePassword && <LoginIcon />}
              sx={{
                fontFamily: "JetBrains Mono, sans-serif",
              }}
            >
              {needsCreatePassword ? "Cadastrar senha" : "Login"}
            </Button>
          </form>
        </div>
      </Paper>
    </Box>
  );
}
